import { __spreadValues } from './chunk-T36PI2YV.mjs';

// src/@types/index.ts
var EmployeeActions = /* @__PURE__ */ ((EmployeeActions2) => {
  EmployeeActions2["ClockIn"] = "clock in";
  EmployeeActions2["ClockOut"] = "clock out";
  EmployeeActions2["LogIn"] = "log in";
  EmployeeActions2["LogOut"] = "log out";
  EmployeeActions2["BreakIn"] = "break in";
  EmployeeActions2["BreakOut"] = "break out";
  EmployeeActions2["EnterOrder"] = "enter order";
  EmployeeActions2["ExitOrder"] = "exit order";
  return EmployeeActions2;
})(EmployeeActions || {});
var EmployeeStatus = /* @__PURE__ */ ((EmployeeStatus2) => {
  EmployeeStatus2["ClockIn"] = "clock in" /* ClockIn */;
  EmployeeStatus2["ClockOut"] = "clock out" /* ClockOut */;
  return EmployeeStatus2;
})(EmployeeStatus || {});
var BASE_STORE_INITIAL_STATE = {
  id: 0,
  createdAt: null,
  updatedAt: null,
  deletedAt: null
};
var AppModules = /* @__PURE__ */ ((AppModules2) => {
  AppModules2["General"] = "general";
  AppModules2["Register"] = "register";
  AppModules2["Menu"] = "menu";
  AppModules2["Settings"] = "settings";
  AppModules2["Management"] = "management";
  AppModules2["Report"] = "report";
  AppModules2["Customers"] = "customers";
  return AppModules2;
})(AppModules || {});
var EGeneralActions = /* @__PURE__ */ ((EGeneralActions2) => {
  EGeneralActions2["logOut"] = "log out";
  EGeneralActions2["logIn"] = "log in";
  EGeneralActions2["clockIn"] = "clock in";
  EGeneralActions2["clockOut"] = "clock out";
  EGeneralActions2["breakIn"] = "break in";
  EGeneralActions2["breakOut"] = "break out";
  return EGeneralActions2;
})(EGeneralActions || {});
var ERegisterActions = /* @__PURE__ */ ((ERegisterActions2) => {
  ERegisterActions2["updateOrder"] = "update order";
  ERegisterActions2["createOrder"] = "create order";
  ERegisterActions2["enterOrder"] = "enter order";
  ERegisterActions2["exitOrder"] = "exit order";
  return ERegisterActions2;
})(ERegisterActions || {});
var EMenuActions = /* @__PURE__ */ ((EMenuActions2) => {
  EMenuActions2["createDiscounts"] = "create discounts";
  EMenuActions2["updateDiscounts"] = "update discounts";
  EMenuActions2["createCategories"] = "create categories";
  EMenuActions2["updateCategories"] = "update categories";
  EMenuActions2["createMenuTypes"] = "create menuTypes";
  EMenuActions2["updateMenuTypes"] = "update menuTypes";
  EMenuActions2["createItems"] = "create items";
  EMenuActions2["updateItems"] = "update items";
  EMenuActions2["deleteItems"] = "delete items";
  EMenuActions2["createModifierGroups"] = "create modifierGroups";
  EMenuActions2["updateModifierGroups"] = "update modifierGroups";
  return EMenuActions2;
})(EMenuActions || {});
var ESettingsActions = /* @__PURE__ */ ((ESettingsActions2) => {
  ESettingsActions2["updateTableLayout"] = "update table layout";
  return ESettingsActions2;
})(ESettingsActions || {});
var AppActions = __spreadValues(__spreadValues(__spreadValues(__spreadValues({}, EGeneralActions), ERegisterActions), EMenuActions), ESettingsActions);
var differenceType = /* @__PURE__ */ ((differenceType2) => {
  differenceType2["ADDED_FIELD"] = "N";
  differenceType2["DELETED_FIELD"] = "D";
  differenceType2["EDITED_FIELD"] = "E";
  differenceType2["ARRAY_CHANGE"] = "A";
  return differenceType2;
})(differenceType || {});

export { AppActions, AppModules, BASE_STORE_INITIAL_STATE, EGeneralActions, EMenuActions, ERegisterActions, ESettingsActions, EmployeeActions, EmployeeStatus, differenceType };
